module.exports = __webpack_public_path__ + "static/img/map_chongqing.1683408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/map_chongqing.png
// module id = Mrpj
// module chunks = 0